import {
  LEVEL_ERROR,
  LEVEL_INFO,
  LEVEL_SUCCESS,
  LEVEL_WARN,
  MESSAGE_DURATION,
} from "constant/messages";
import PropTypes from "prop-types";
import React from "react";
import Alert from "react-bootstrap/Alert";
import Button from "react-bootstrap/Button";
import { RawHtml } from "ui/raw-html";

import { getPrioritizedUserMessages } from "./utils";

const PropTypeMessages = PropTypes.shape({
  level: PropTypes.oneOf([LEVEL_ERROR, LEVEL_INFO, LEVEL_SUCCESS, LEVEL_WARN])
    .isRequired,
  message: PropTypes.string.isRequired,
});

class Messages extends React.PureComponent {
  static get propTypes() {
    return {
      clearAll: PropTypes.func,
      messages: PropTypes.arrayOf(PropTypeMessages),
    };
  }

  static get defaultProps() {
    return {
      clearAll: () => {},
    };
  }

  constructor() {
    super();

    this.timerId = null;

    this.init = this.init.bind(this);
    this.initDismissTimeout = this.initDismissTimeout.bind(this);
    this.buttonClick = this.buttonClick.bind(this);
    this.clearMessage = this.clearMessage.bind(this);
    this.clearTimeout = this.clearTimeout.bind(this);

    this.state = {
      dismissing: false,
    };

    this.lastMessage = null;
  }

  componentDidUpdate() {
    this.init();
  }

  init() {
    const { messages: rawMessages } = this.props;
    const messages = getPrioritizedUserMessages(rawMessages);
    const top = messages[0];

    if (top && top !== this.lastMessage) {
      this.setState({ dismissing: false }, () => {
        this.initDismissTimeout(top);
      });
    }

    this.lastMessage = top;
  }

  initDismissTimeout(top) {
    this.clearTimeout();

    if (top.level === LEVEL_SUCCESS) {
      this.setState({ dismissing: true });
      this.timerId = setTimeout(this.clearMessage, MESSAGE_DURATION);
    }
  }

  buttonClick() {
    const { clearAll } = this.props;
    const { dismissing } = this.state;

    // If we're dismissing, button click should cancel the dismiss.
    if (dismissing) {
      this.setState({ dismissing: false });
      this.clearTimeout();
      return;
    }

    // Otherwise the button should clear the message.
    clearAll();
  }

  clearMessage() {
    const { clearAll } = this.props;

    this.timerId = null;

    clearAll();
  }

  clearTimeout() {
    if (this.timerId) {
      clearTimeout(this.timerId);
      this.timerId = null;
    }
  }

  renderMessage(messages) {
    const { dismissing } = this.state;
    let className = "";
    let iconClass = "fa-close";
    let title = "Dismiss";
    if (messages.length === 0) {
      return null;
    }

    const top = messages[0];
    const { created, level, message } = top;

    if (level === LEVEL_SUCCESS) {
      className = "auto-dismiss";
      iconClass = dismissing ? "fa-pause" : "fa-close";
      title = dismissing ? "Pause" : "Dismiss";
    }

    return (
      <Alert
        key={created}
        variant={level}
        className={`small-alert ${className}`}
      >
        <div className="message-wrapper">
          <div className="message-message">
            <RawHtml html={message} />
          </div>
          <div className="message-controls">
            <Button
              className="small-button light-button clear-button"
              title={title}
              onClick={this.buttonClick}
            >
              <i className={"fa " + iconClass} />
            </Button>
          </div>
        </div>
        {level === LEVEL_SUCCESS && (
          <div className={`message-timeout ${dismissing ? "animate" : ""}`} />
        )}
      </Alert>
    );
  }

  render() {
    const { messages: rawMessages } = this.props;
    const messages = getPrioritizedUserMessages(rawMessages);

    const noMessages = messages.length === 0;
    if (noMessages) {
      return null;
    }

    return (
      <div className="ui-messages">
        <div className="message-title">
          <h4>Messages</h4>
        </div>
        <div className="ui-message-container">
          <div className="message-container">
            {this.renderMessage(messages)}
          </div>
        </div>
      </div>
    );
  }
}

export { Messages };
